import { store } from '../../../packages/neb-redux/neb-redux-store';
import { getSessionInfo } from '../../utils/session-util';

export const getUserEmailContext = () => {
  const { session } = store.getState();

  if (session && session.item) {
    const sessionInfo = getSessionInfo(session);
    return sessionInfo.email ? { userEmail: sessionInfo.email } : {};
  }
  return {};
};
